import {
  SHOW_NOTIFICATION,
  HIDE_NOTIFICATION,
  SHOW_ERROR_NOTIFICATION,
  SET_LOADING_TEXT,
  AppActionTypes,
} from '../types';

export const showNotification = (message: string | React.ReactElement): AppActionTypes => ({
  type: SHOW_NOTIFICATION,
  message,
});

export const hideNotification = (): AppActionTypes => ({
  type: HIDE_NOTIFICATION,
});

export const showErrorNotification = (message: string | React.ReactElement): AppActionTypes => ({
  type: SHOW_ERROR_NOTIFICATION,
  message,
});

export const setLoadingText = (text: string): AppActionTypes => ({
  type: SET_LOADING_TEXT,
  payload: text,
});

export const reportError = (error: string) => ({
  type: 'ADD_ERROR',
  error,
});

export const setLoading = (isLoading: boolean) => ({
  type: 'IS_LOADING',
  isLoading,
});
